import { Pipe, PipeTransform } from '@angular/core';

import { IProject } from '../../shared/models/project.model';

@Pipe({
    name: 'canEditProject',
    standalone: false
})
export class CanEditProjectPipe implements PipeTransform {

  transform(project: IProject): boolean {
    if (project?.isArchived) {
      return false;
    }
    return project?.canEditProject;
  }

}
